import { z } from "zod";
/**
 * Who an account belongs to, decided once when the account is created (journey audit,
 * 2026-10-16). Every metric and event carries it, so real customers can be counted on their own
 * and tests, demos and staff kept out of business numbers. It replaces the old `test` flags,
 * which meant something different in every record.
 */
export const customerAudienceSchema = z.enum([
    "CUSTOMER",
    "PARTNER_DEMO",
    "OWNER_TEST",
    "AUTOMATED_TEST",
    "STAFF",
]);
/** Which rule decided an account's audience. */
export const customerAudienceRuleSchema = z.enum([
    "SES_SIMULATOR",
    "TEST_ALIAS",
    "RESERVED_TEST_DOMAIN",
    "AUTOMATION_ACCOUNT",
    "OWNER_ACCOUNT",
    "STAFF_ACCOUNT",
    "COMPANY_DOMAIN",
    "PARTNER_VOUCHER",
    "DEFAULT",
]);
/** Only real customers count as live business; demos, tests and staff are kept apart. */
export function audienceCountsAsLive(audience) {
    return audience === "CUSTOMER";
}
//# sourceMappingURL=audience.js.map